import React from 'react'
export const ProductContext = React.createContext({});
export const ProductProvider = ProductContext.Provider;
export const ProductConsumer = ProductContext.Consumer;

